import { getDataMapper, mapField } from "@/shared";

export const mapMessageTemplateToServer = getDataMapper({
    name: mapField("name"),
    event: mapField("event"),
    text: mapField("text"),
    is_active: mapField("isActive"),
    remain_period: mapField("remainPeriod"),
});
